import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "select"]
  static values = {
    url: String,
    field: String,
    model: { type: String, default: "task" }
  }

  connect() {
    this.open = false
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.open) {
      this.close()
    } else {
      this.displayTarget.classList.add("hidden")
      this.selectTarget.classList.remove("hidden")
      this.selectTarget.focus()
      this.open = true
    }
  }

  change() {
    const value = this.selectTarget.value
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const body = { [this.modelValue]: {} }
    body[this.modelValue][this.fieldValue] = value

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify(body)
    }).then(response => {
      if (response.ok) {
        const selectedOption = this.selectTarget.options[this.selectTarget.selectedIndex]
        const textNode = this.displayTarget.querySelector(".rw-inline-display-text") || this.displayTarget
        const newLabel = selectedOption.text

        if (!value || value.length === 0) {
          textNode.textContent = "— Ajouter"
          this.element.closest(".rw-inline-field")?.querySelector(".rw-inline-field-value")?.classList.add("is-empty")
        } else {
          textNode.textContent = newLabel
          this.element.closest(".rw-inline-field")?.querySelector(".rw-inline-field-value")?.classList.remove("is-empty")
        }

        const newClasses = selectedOption.dataset.classes
        if (newClasses) {
          this.displayTarget.className = `px-2 py-1 text-[10px] font-semibold rounded border ${newClasses} border-current/20 cursor-pointer hover:opacity-80 transition-opacity`
        }
        this.close()
        this.flashSuccess()
      }
    })
  }

  close() {
    this.open = false
    this.displayTarget.classList.remove("hidden")
    this.selectTarget.classList.add("hidden")
  }

  handleBlur() {
    setTimeout(() => this.close(), 150)
  }

  flashSuccess() {
    const field = this.element.closest(".rw-inline-field")
    if (!field) return
    field.classList.remove("is-just-saved")
    void field.offsetWidth
    field.classList.add("is-just-saved")
    setTimeout(() => field.classList.remove("is-just-saved"), 1200)
  }
}
